export default __webpack_public_path__ + "static/media/banner1.66cc4980.jpg";